import './PaymentMethodDetails.pcss';
import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { StoreState } from '@mm/state/store-interfaces';
import { selectAccountDetails } from '@mm/state/selectors/subscriptionSelectors';

type OuterProps = { className?: string };

type InnerProps = ReturnType<typeof mapStateToProps>;

type Props = OuterProps & InnerProps;

const PaymentMethodDetails = (props: Props) => {
  const { accountDetails, className } = props;
  const account = accountDetails ? accountDetails.account : undefined;
  const editBillingLink =
    account && account.editBillingLink ? account.editBillingLink : '';

  if (account) {
    return (
      <div className={classnames('payment-method-details', className)}>
        <div className="payment-method-details__billing">
          <div className="payment-method-details__billed-with-text">
            Billed With:{' '}
          </div>

          <div className="payment-method-details__card-details">
            XXXX XXXX XXXX {account.lastCardNumbers}
          </div>
          <a
            href={editBillingLink}
            target="_blank"
            rel="noopener noreferrer"
            className="payment-method-details__edit-billing-info"
          >
            Edit Billing Info
          </a>
        </div>
      </div>
    );
  }

  return null;
};

const mapStateToProps = (state: StoreState) => ({
  accountDetails: selectAccountDetails(state),
});

const enhance = compose<InnerProps, OuterProps>(connect(mapStateToProps));

export default enhance(PaymentMethodDetails);
